var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalBetAmountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.11 339.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "total_bet_amount_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2637.17,2450.37c-.48,1.52-1,3-1.43,4.56a27.55,27.55,0,0,1-11.18,15.38c-16.73,11.09-33.07,22.78-50.11,33.37a164.66,164.66,0,0,1-94,25.12c-14.28-.46-28.53-2.72-42.72-4.68-26.78-3.7-53.5-7.78-80.25-11.72-1.23-.18-2.44-.46-3.79-.73v-125c1.44-.08,2.76-.23,4.07-.23,8.48,0,17,.12,25.45-.12a8.83,8.83,0,0,0,5.46-2.28c16.07-15.86,31.87-32,48-47.8,18.32-18,49.41-10,56.23,14.47,3.57,12.81.43,24.21-8.9,33.72-8.73,8.9-17.62,17.64-26.65,26.66a97.86,97.86,0,0,0,30.32,17.58c29.35,10.73,58.36,9.7,87-2.71,6.4-2.76,12.89-5.31,19.37-7.9,19.21-7.7,37.85,2.14,42.45,22.37a14.46,14.46,0,0,0,.62,1.74Z",
    transform: "translate(-2254.06 -2193.67)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2637.17,2238.46c-1.81,8-4.7,15.38-10.32,21.57a39.7,39.7,0,0,1-46.17,9.3c-15.82-7.38-25.22-24.5-22.68-41.32,2.67-17.69,15.88-31.17,33.17-33.85a39.59,39.59,0,0,1,45.28,31.78,15.47,15.47,0,0,0,.72,2Z",
    transform: "translate(-2254.06 -2193.67)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2330.76,2533.3h-76.7V2361.18h76.7Z",
    transform: "translate(-2254.06 -2193.67)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2454.29,2284.26a39.73,39.73,0,1,1,39.62-39.83A39.68,39.68,0,0,1,2454.29,2284.26Z",
    transform: "translate(-2254.06 -2193.67)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2564.43,2363.82a39.75,39.75,0,1,1,39.75-39.72A39.58,39.58,0,0,1,2564.43,2363.82Z",
    transform: "translate(-2254.06 -2193.67)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBetAmountIcon);
export default __webpack_public_path__ + "static/media/total_bet_amount_icon.5121e5af059416da3dd916628b3068d3.svg";
export { ForwardRef as ReactComponent };